<template>
  <div class="AppMissionDetail">
    <div class="amd_title">
      <div>学习目标</div>
      <img src="/static/app/titlebg01.png" />
    </div>
    <div class="amd_page1 flex_start">
      <div
        class="page1_item"
        v-for="(item, index) in targetlist[title]"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="amd_title top88">
      <div>记录成长</div>
      <img src="/static/app/titlebg01.png" />
    </div>
    <div class="amd_page2">
      <div>{{ growuplist[title] }}</div>
      <div class="red">（点击页面底部“上传作品”；或进入博物馆上传作品）</div>
    </div>
    <div class="amd_title top88">
      <div>学习内容</div>
      <img src="/static/app/titlebg01.png" />
    </div>
    <div class="amd_page3">
      <div class="page3_img">
        <img :src="taskInfo.taskCoverImagePath" @click="show_big_img"/>
        <div class="video" v-if="taskfiletype == 2">
          <img
            :src="
              audio_play
                ? '/static/app/icon_stopaudio.png'
                : '/static/app/btn_bofang.png'
            "
            @click="play_audio"
            class="icon_play"
          />
          <audio :src="taskInfo.ShowFilePath" style="display:none;" id="audio"/>
        </div>
      </div>
      <div class="tasktype3" v-if="taskfiletype == 3">
        <div>（点击图片可放大查看）</div>
      </div>
      <div class="page3_text">
        <img
          :src="taskInfo.taskChengYuDescShowUrl"
          class="md_cy"
          v-if="
            taskInfo.taskCategory == 'enyShiGe' &&
            taskInfo.taskChengYuDescShowUrl
          "
        />
      </div>
      <div class="c_text">
        <div class="c_title">{{ title_text }}</div>
        <img
          class="line"
          :class="title_text == '考拉锦囊' ? '' : 'lines'"
          :src="
            title_text == '考拉锦囊'
              ? '/static/app/titlebg01.png'
              : '/static/app/titlebg02.png'
          "
        />
      </div>
      <div class="artile" v-html="taskInfo.taskContent"></div>
    </div>
    <div class="amd_title top88">
      <div>温馨提示</div>
      <img src="/static/app/titlebg01.png" />
    </div>
    <div class="amd_page4">{{ hintlist[title] }}</div>
    <div class="amd_pageimg" @click="hide_big_img" v-if="show_bigimg">
      <img :src="taskInfo.taskCoverImagePath"/>
    </div>
  </div>
</template>
<script>
import http from "../../../service/http";
export default {
  name: "AppMissionDetail",
  data() {
    return {
      targetlist: {
        enyShiGe: [
          "一级目标：顺利识读",
          "二级目标：流利朗读",
          "三级目标：背诵自如",
          "四级目标：拓展认知",
        ],
        enyGuShi: [
          "一级目标：顺利识读",
          "二级目标：流利朗读",
          "三级目标：自由讲述",
          "四级目标：拓展认知",
        ],
        enyZiTie: [
          "一级目标：临摹和独立书写",
          "二级目标：独立默写",
          "三级目标：讲述相关造字规律",
        ],
        enyGeYao: [
          "一级目标：顺利识读",
          "二级目标：流利朗读",
          "三级目标：背诵自如",
          "四级目标：拓展认知",
        ],
      },
      growuplist: {
        enyGeYao: "拍摄孩子朗读或背诵的小视频并上传到中文博物馆",
        enyShiGe: "拍摄孩子朗读或背诵的小视频并上传到中文博物馆",
        enyZiTie:
          "拍摄孩子写出的汉字的照片，或拍摄孩子写字的小视频并上传到中文博物馆",
        enyGuShi: "拍摄孩子朗读或讲述的小视频并上传到中文博物馆",
      },
      hintlist: {
        enyGeYao:
          "歌谣在4-12岁海外华裔少儿学习中文的过程中，作用和意义重大，其价值不在于“点”，而在于“线”和“面”，单个字和词的难易不会影响歌谣对中文学习的整体意义。",
        enyShiGe:
          "家长在鼓励孩子收听和学习诗词时可以放松心态，在中文诗词的韵律中先重点培养孩子的语感，在语感中进入语境，再反过来理解诗词的字面意思，进而体会文字背后的含义。这是一个循序渐进的过程。不急不躁，静待花开。",
        enyZiTie:
          "汉字的书写，不能着急。对汉字笔画的书写规律，以及汉字结构的平面视觉感受的培养不是一蹴而就的，它有一个从逐渐习惯到自如，再到透出美感的循序渐进的过程。此外，笔顺是自古以来人们总结下来最舒服、最顺手的笔画书写顺序，因此，如果孩子在书写过程中，出现与参考笔顺的不一致，并不是对错层面的问题，给予建议即可，不必过于在意。",
        enyGuShi:
          "家长在鼓励孩子收听和学习成语故事时可以放松心态，先重点培养孩子的兴趣和语感，在语感中进入语境，再反过来通过成语故事讲述的意思与成语本身对照认知，通过成语可以“望文生义”这个最大的特点，辅助理解字面意思，进而体会文字和故事背后的含义。这是一个循序渐进的过程。不急不躁，静待花开。",
      },
      xitong_title: {
        enyGeYao: "一首歌谣",
        enyShiGe: "一首诗词",
        enyZiTie: "一张字帖",
        enyGuShi: "一个成语故事",
      },
      taskId: "",
      title: "",
      taskfiletype: "",
      title_text: "",
      taskInfo: [],
      img_host: "https://www.koalaknow.com/img/webapp-img/",
      audio_play: false,
      show_bigimg:false,
    };
  },
  mounted() {
    this.taskId = http.getQueryString("taskId");
    this.title = http.getQueryString("title");
    this.taskfiletype = http.getQueryString("taskfiletype");
    this.title_text =
      this.title == "enyShiGe"
        ? "原文"
        : this.title == "enyGuShi"
        ? "释义"
        : "考拉锦囊";
    document.title = this.xitong_title[this.title];
    this.get_task_info(this.taskId);
  },
  methods: {
    get_task_info(taskId) {
      var that = this;
      var data = {
        cmd: "GetTaskInfoById",
        taskId: taskId,
      };
      http.req(
        data,
        function (res) {
          that.taskInfo = res.info;
        },
        "https://apinew.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1"
      );
    },
    //播放音频
    play_audio() {
        var audio=document.getElementById('audio');
        if (this.audio_play) {
            this.audio_play = false;
        audio.pause();
        }else{
             this.audio_play = true;
            audio.play();
        }
    //   var audio_url = this.taskInfo.ShowFilePath;
    //   var audio = new Audio(audio_url);
    //   if (this.audio_play) {
    //     audio.pause();
    //     this.audio_play = false;
    //   } else {
    //     this.audio_play = true;
    //     var audio_play = this.audio_play;
    //     audio.play();
    //   }
    },
    //展示放大后的图片
    show_big_img(){
      var that=this;
      if(that.taskfiletype==3){
        that.show_bigimg=true;
      }
    },
    hide_big_img(){
this.show_bigimg=false;
    }
  },
};
</script>
<style scoped>
.AppMissionDetail {
  background: #fff;
  padding: 40px 40px 170px;
  box-sizing: border-box;
  color: #313131;
}
.amd_title {
  text-align: center;
  color: #ce1a13;
  font-size: 42px;
  font-weight: bold;
  margin: 0 0 30px 0;
}
.amd_title img {
  width: 159px;
}
.amd_page1 {
  font-size: 28px;
  line-height: 40px;
}
.amd_page1 .page1_item {
  width: 50%;
  flex-shrink: 0;
  -webkit-flex-shrink: 0;
  text-align: center;
  white-space: nowrap;
}
.top88 {
  margin-top: 88px;
}
.amd_page2 {
  font-size: 28px;
  text-align: center;
  line-height: 40px;
}
.amd_page2 .red {
  color: #c12c20;
}
.amd_page3 {
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  background: rgb(248, 226, 224);
}
.page3_img {
  width: 100%;
  height: 376px;
  position: relative;
}
.page3_img .video {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 84px;
  height: 84px;
}
.page3_img .video img {
  width: 100%;
  height: 100%;
}
.page3_img img {
  width: 100%;
  height: 100%;
}
.page3_text .md_cy {
  width: 100%;
  height: auto;
  margin: 20px auto 0;
}
.amd_page3 .c_text {
  text-align: center;
  font-size: 42px;
  color: #ce1a13;
  font-weight: bold;
  margin: 60px auto 0;
}
.amd_page3 .c_text .line {
  width: 159px;
}
.amd_page3 .c_text .lines {
  width: 70px;
}
.amd_page4 {
  font-size: 28px;
  line-height: 40px;
}
.tasktype3 {
  font-size: 30px;
  margin: 32px auto 0;
  text-align: center;
  line-height: 40px;
}
.amd_pageimg{
  position: fixed;
  width: 100vw;
height: 100vh;
top: 0;
left: 0;
z-index: 2;
background: rgba(0,0,0,.6);
}
.amd_pageimg img{
    height: 100vw;
    transform: translate(-50%,-50%) rotate(90deg);
    position: absolute;
    top: 50%;
    left: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/App/App_mission_detail.vue